import {loadLazy as ll} from 'uix/parts'

export const UserList = ll(() => import(/* webpackChunkName: 'user' */ './userlist'))
export const MailList = ll(() => import(/* webpackChunkName: 'user' */ './mail'))
export const UserDashboard = ll(() => import(/* webpackChunkName: 'user' */ './dashboard'))
